module.exports = __webpack_public_path__ + "static/media/Abogados logo.8767320a.png";